import React, {useContext} from 'react';
// import {GoArrowDown} from 'react-icons/go';
import {Badge, FluidContainer, Media} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
import {
  TeamsCard,
  CardsWrapper,
  CardsContainer,
  TeamsCardFront,
  TeamsCardHeader,
  TeamsCardMiddle,
  TeamsCardFooter,
  TeamsCardFrontTitle,
  TeamsCardMiddleLine,
  TeamsCardFooterItem,
  TeamsCardFooterBadge,
  TeamsCardHeaderExport,
  TeamsCardMiddleWrapper,
  TeamsCardFrontSubtitle,
  TeamsCardFooterBadgeSpan,
  TeamsCardFooterBadgeItem,
  // TeamsCardHeaderExportSpan,
  TeamsCardMiddleWrapperSpan,
} from './styles';
import { useNavigate } from 'react-router-dom';

export default ({teamMemo, inputValue}) => {
  const {HandleSelectedTeam} = useContext(ARMcontext);
  const navigate = useNavigate();

  function handleDownload(e: any): void {
    e.stopPropagation();
    alert('Downloading');
  }

  function handleCard(selectedTeam: any | object): void {
    HandleSelectedTeam(selectedTeam);
    navigate('/players/dashboard');
  }

  return (
    <CardsWrapper>
      <FluidContainer>
        <CardsContainer data-cy="cards">
          {teamMemo
            .filter(el => el.name.toLowerCase().includes(inputValue.value.toLowerCase()))
            .map((el, idx) => (
              <TeamsCard key={idx} onClick={() => handleCard(el)}>
                <TeamsCardHeader>
                  <TeamsCardHeaderExport onClick={handleDownload}>
                    {/* <GoArrowDown color="#ACB1C0" />
                    <TeamsCardHeaderExportSpan>XLSX</TeamsCardHeaderExportSpan> */}
                  </TeamsCardHeaderExport>
                </TeamsCardHeader>
                <TeamsCardFront>
                  {el.picture && el.name !== 'All Players' ? (
                    <Media imgUrl={el.picture} size="120px" mRight="0" />
                  ) : el.badge === 'ALL' ? (
                    <Badge color="#007AFF" size={'116px'} font={'40px'} />
                  ) : (
                    <Badge text={el?.badge || el.initials} color={el?.color} size={'116px'} font={'40px'} />
                  )}
                  <TeamsCardFrontTitle>{el.name}</TeamsCardFrontTitle>
                  <TeamsCardFrontSubtitle>{el?.organizationName?.toUpperCase() || 'UNDEFINED'}</TeamsCardFrontSubtitle>
                </TeamsCardFront>
                <TeamsCardMiddle>
                  <TeamsCardMiddleLine></TeamsCardMiddleLine>
                  <TeamsCardMiddleWrapper>
                    <TeamsCardMiddleWrapperSpan>{el.totalPlayers} PLAYERS</TeamsCardMiddleWrapperSpan>
                  </TeamsCardMiddleWrapper>
                  <TeamsCardMiddleLine></TeamsCardMiddleLine>
                </TeamsCardMiddle>
                <TeamsCardFooter>
                  <TeamsCardFooterItem>
                    <TeamsCardFooterBadge>
                      <TeamsCardFooterBadgeItem>
                        <Badge
                          text={el?.pitchers?.toString()}
                          color="#ACB1C0"
                          weight="500"
                          size={'25px'}
                          font={'12px'}
                          family="Proxima Nova"
                        />
                      </TeamsCardFooterBadgeItem>
                      <TeamsCardFooterBadgeSpan>PITCHERS</TeamsCardFooterBadgeSpan>
                    </TeamsCardFooterBadge>
                    <TeamsCardFooterBadge>
                      <TeamsCardFooterBadgeItem>
                        <Badge
                          text={el?.catchers?.toString()}
                          color="#ACB1C0"
                          weight="500"
                          size={'25px'}
                          font={'12px'}
                          family="Proxima Nova"
                        />
                      </TeamsCardFooterBadgeItem>
                      <TeamsCardFooterBadgeSpan>CATCHERS</TeamsCardFooterBadgeSpan>
                    </TeamsCardFooterBadge>
                  </TeamsCardFooterItem>
                  <TeamsCardFooterItem>
                    <TeamsCardFooterBadge>
                      <TeamsCardFooterBadgeItem>
                        <Badge
                          text={el?.infielders?.toString()}
                          color="#ACB1C0"
                          weight="500"
                          size={'25px'}
                          font={'12px'}
                          family="Proxima Nova"
                        />
                      </TeamsCardFooterBadgeItem>
                      <TeamsCardFooterBadgeSpan>INFIELDERS</TeamsCardFooterBadgeSpan>
                    </TeamsCardFooterBadge>
                    <TeamsCardFooterBadge>
                      <TeamsCardFooterBadgeItem>
                        <Badge
                          text={el?.outfielders?.toString()}
                          color="#ACB1C0"
                          weight="500"
                          size={'25px'}
                          font={'12px'}
                          family="Proxima Nova"
                        />
                      </TeamsCardFooterBadgeItem>
                      <TeamsCardFooterBadgeSpan>OUTFIELDERS</TeamsCardFooterBadgeSpan>
                    </TeamsCardFooterBadge>
                  </TeamsCardFooterItem>
                </TeamsCardFooter>
              </TeamsCard>
            ))}
        </CardsContainer>
      </FluidContainer>
    </CardsWrapper>
  );
};
